import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Promise from 'promise-polyfill';

// Add promise polyfill if no browser support
if (!window.Promise) {
	window.Promise = Promise;
}

// Polyfill for js 'find' function
if (!Array.prototype.find) {
    Array.prototype.find = function(predicate) {
        if (this == null) {
            throw new TypeError('Array.prototype.find called on null or undefined');
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[1];
        var value;

        for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
                return value;
            }
        }
        return undefined;
    };
}

// ELEMENTARY --------------------------

const elementary = require('./vendor/elementary.js');

window.addEventListener( 'load', elementary, false );
window.addEventListener( 'resize', elementary, false );

// NAV --------------------------

const Nav = require('bluegg-nav');

var mainNav = new Nav({
	nav: '.nav--primary',
	trigger: '#primary-nav-trigger'
});

// PRODUCT QUICKLINKS ---------------------

// document.getElementById('products-nav-trigger').addEventListener('click', function(e) {
// 	e.preventDefault();
// 	document.getElementsByTagName('body')[0].classList.toggle('quicklinks-open');
// })

// RACF SELECTOR --------------------------

import RACFSelector from './modules/racf-selector/RACFSelector';
var racfContainer = $('#racf-selector');

if (racfContainer.length)
{
	var filtersUrl      = racfContainer.data('filtersUrl');
	var productTypesUrl = racfContainer.data('productTypesUrl');

	ReactDOM.render(
		<RACFSelector filtersUrl={ filtersUrl } productTypesUrl={ productTypesUrl } />,
		document.getElementById('racf-selector')
	);
}

// FLAT ROOF PRODUCT SELECTOR --------------------------

import FRPSelector from './modules/frp-selector/FRPSelector';
var frpContainer = $('#frp-selector');

if (frpContainer.length)
{
	var filtersUrl      = frpContainer.data('filtersUrl');
	var productTypesUrl = frpContainer.data('productTypesUrl');

	ReactDOM.render(
		<FRPSelector filtersUrl={ filtersUrl } productTypesUrl={ productTypesUrl } />,
		document.getElementById('frp-selector')
	);
}

// RACSS SELECTOR --------------------------

// import RACSSSelector from './modules/racss-selector/RACSSSelector';
// if (document.body.contains(document.getElementById('racss-selector')))
// {
// 	ReactDOM.render(
// 		<RACSSSelector />,
// 		document.getElementById('racss-selector')
// 	);
// }

// SP SELECTOR --------------------------

import SPSelector from './modules/sp-selector/SPSelector';
var spContainer = $('#sp-selector');

if (spContainer.length)
{
	var filtersUrl      = spContainer.data('filtersUrl');
	var productTypesUrl = spContainer.data('productTypesUrl');

	ReactDOM.render(
		<SPSelector filtersUrl={ filtersUrl } productTypesUrl={ productTypesUrl } />,
		document.getElementById('sp-selector')
	);
}

// FLAT ROOF PRODUCT SELECTOR --------------------------

import TASelector from './modules/ta-selector/TASelector';
var taContainer = $('#ta-selector');

if (taContainer.length)
{
	var filtersUrl      = taContainer.data('filtersUrl');
	var productTypesUrl = taContainer.data('productTypesUrl');

	ReactDOM.render(
		<TASelector filtersUrl={ filtersUrl } productTypesUrl={ productTypesUrl } />,
		document.getElementById('ta-selector')
	);
}

// RESOURCE SELECTOR --------------------------

import ResourceSelector from './modules/resource-selector/ResourceSelector';
if (document.body.contains(document.getElementById('resource-selector')))
{
	var el           = document.getElementById('resource-selector');
	var categoryId   = el.dataset.categoryId;
	var categoryName = el.dataset.categoryName;

	ReactDOM.render(
		<ResourceSelector categoryId={ categoryId } categoryName={ categoryName } />,
		document.getElementById('resource-selector')
	);
}

// AJAX PAGINATION ----------------------------

import Pagination from './modules/pagination';
if ($('[data-pagination-trigger]').length)
{
	Pagination.init();
}

// PARSLEY --------------------------

import parsley from 'parsleyjs';

if ($('form').length) {

	$('form').parsley({
		errorClass: 'form-control--error',
		errorsWrapper: '<ul class="form-errors"></ul>',
		errorTemplate: '<li class="form-errors__item"></li>',
		classHandler: function(ParsleyField) {
			if (ParsleyField.element.nodeName == 'SELECT') {
				return ParsleyField.$element.parent().parent().parent();
			} else {
				return ParsleyField.$element.parent().parent();
			}

		},
		errorsContainer: function(ParsleyField) {
			if (ParsleyField.element.nodeName == 'SELECT') {
				return ParsleyField.$element.parent().parent().parent().find('.form-control__errors');
			}
			else {
				return ParsleyField.$element.parent().parent().find('.form-control__errors');
			}

		}
	});

}

// NAV TERTIARY TRIGGER
$('.nav--tertiary .heading').on('click', function()
{
	$(this).parent().toggleClass('is-open');
});

// GOOGLE ANALYTICS EVENTS
if (typeof gtag === 'function') {

	$('[data-ga-event]').on('click', function() {
		const arrEventData = $(this).data('ga-event').split('|');

		// When split into array, indexes correspond thus:
		// 0: category
		// 1: action
		// 2: label
		// 3: value

		let fieldsObject = {
			event_category: arrEventData[0],
		};
		if (arrEventData[2])
		{
			fieldsObject.event_label = arrEventData[2];
		}
		if (arrEventData[3])
		{
			fieldsObject.value = arrEventData[3];
		}

		console.log(fieldsObject);

		let result = gtag('event', arrEventData[1], fieldsObject);
		console.log(result);
	})
}

// CHOSEN PRODUCT ON CONTACT PAGE
const chosenProductEl = document.querySelector("[data-chosen-product]");

// If chosen product element found
if (chosenProductEl !== null) {

	const chosenProductClose = chosenProductEl.querySelector("[data-chosen-product-close]"); // Close button on chosen product
	const chosenProductFld   = document.getElementById('chosen-product-value'); // Hidden field containing product id

	// If close button found
	if (chosenProductClose !== null) {

		// When button clicked
		chosenProductClose.addEventListener('click', function(e) {

			// Remove hidden field if present
			if (chosenProductFld !== null) {
				chosenProductFld.remove();
			}

			// Remove chosen product element
			chosenProductEl.remove();
		});
	}
}
